import { render, staticRenderFns } from "./purchase-sale-list.vue?vue&type=template&id=39014bc5&scoped=true&"
import script from "./purchase-sale-list.vue?vue&type=script&lang=js&"
export * from "./purchase-sale-list.vue?vue&type=script&lang=js&"
import style0 from "./purchase-sale-list.vue?vue&type=style&index=0&id=39014bc5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39014bc5",
  null
  
)

export default component.exports